import ClientBase from "./ClientBase";
import AuthZeroMember from "@/domain/authorization/AuthZeroMember";
import AuthZeroOrganizationViewModel from "@/domain/authorization/AuthZeroOrganizationViewModel";
import AuthZeroRole from "@/domain/authorization/AuthZeroRole";

class AuthZeroClient extends ClientBase {
    /**
     * Get all members of an Auth0 organization (via your backend).
     * @param {string} orgId - The Auth0 organization ID.
     * @returns {Promise<Object[]>} - List of members.
     */


    async getMembersByOrg(orgId) {
        const response = await this.get(`api/v1/auth/organization/${orgId}/members`);
        return response.map(member => new AuthZeroMember(member));
    }

    async getAssignableRoles(){
        const response = await this.get('api/v1/auth/available-roles');
        return response.map(role => new AuthZeroRole(role));
    }

    /**
     * Create a new Auth0 user (via your backend).
     * @param {Object} userData - { email, password, connection }
     * @returns {Promise<Object>} - Created user.
     */
    async createUser(userData) {
        return await this.post('api/v1/auth/organizations/user', userData);
    }

    /**
     * Delete an Auth0 user by user ID (via your backend).
     * @param {Object} request - The Auth0 user ID & Org ID.
     * @returns {Promise<void>}
     */
    async deleteUser(orgId, userId) {
        return await this.delete(`api/v1/auth/organizations/${orgId}/user/${userId}`);
    }

    async assignRoles(orgId, userId, previousRoleId, newRoleId){
        const endpoint = `api/v1/auth/organizations/${orgId}/members/roles`
        const data = { "userId": userId, "previousRoleId": previousRoleId, "newRoleId": newRoleId }

        return await this.put(endpoint, data);
    }

    async getOrganizationById(organizationId){
        const endpoint = `api/v1/auth/organizations/${organizationId}`;
        const data = await this.get(endpoint);

        return data ? new AuthZeroOrganizationViewModel(data) : null;
    }
}

export default new AuthZeroClient();